<template>
  <div class="boss-main-wrap boss-main-content-wrap">
    <setting-header
      :breadcrumbs="[{ name: '社員からの評判', pathName: 'realIntentionTop' }]"
      :title="`社員からの評判＿${title}`"
      data-test="title-real-intention"
    />
    <div class="margin-top-1">
      <h3 class="boss-joboffer-title boss-setting">
        回答者データ
      </h3>
    </div>

    <div class="cell-auto">
      <form-label label="性別">
        <template #body>
          <div>
            <label
              v-for="(option) in genders"
              :key="option.id"
              class="align-center margin-right-1 pega-input pega-realintention-radio-area"
            >
              <input
                v-model="realIntention.gender"
                :data-test="`gender-${option.id}`"
                :value="{id:option.id, name:option.name}"
                :checked="realIntention.gender.id === option.id"
                class="boss-input-checkbox"
                name="gender"
                type="radio"
              >{{ option.name }}
            </label>
          </div>
        </template>
      </form-label>
      <form-item-number
        v-model="realIntention.age"
        placeholder="半角数字のみ"
        :max-number="99"
        :min-number="1"
        :errors="[ageValidation]"
        data-test="age"
        form-label-class-name="medium-3,cell pega-form-label"
        class-name="pega-realintention-number-area"
      >
        <template #label>
          <label>
            年齢<br>
            <small>（半角数字のみ）</small>
          </label>
        </template>
        <template #suffix>
          <span>歳</span>
        </template>
      </form-item-number>
      <div>
        <form-item
          v-model="realIntention.post"
          :class-name="postValidation.isShow ? 'is-invalid-input': ''"
          data-test="post"
        >
          <template #label>
            所属部署・職種<br>
            <small>（200文字以内）</small>
          </template>
          <template #header>
            <small>{{ realIntention.post.length }}文字／{{ post_max }}文字</small>
          </template>
          <template #error>
            <validation-label
              v-if="postValidation.isShow"
              data-test="post-error"
              :label="postValidation.message"
            />
          </template>
        </form-item>
      </div>
      <form-label label="キャリア">
        <template #body>
          <div>
            <label
              v-for="(option) in realIntentionOptions.career"
              :key="option.id"
              class="align-center margin-right-1 pega-input pega-realintention-radio-area"
            >
              <input
                v-model="realIntention.career"
                :data-test="`career-${option.id}`"
                :value="{id:option.id, name:option.name}"
                :checked="realIntention.career.id === option.id"
                class="boss-input-checkbox"
                name="career"
                type="radio"
              >{{ option.name }}
            </label>
          </div>
        </template>
      </form-label>
      <form-item-number
        v-model="realIntention.serviceYear"
        placeholder="半角数字のみ"
        :max-number="99"
        :min-number="1"
        :errors="[serviceYearValidation]"
        data-test="service-year"
        form-label-class-name="medium-3,cell pega-form-label"
        class-name="pega-realintention-number-area"
      >
        <template #label>
          <label>
            入社年数<br>
            <small>（半角数字のみ）</small>
          </label>
        </template>
        <template #suffix>
          <span>年目</span>
        </template>
      </form-item-number>
      <form-label label="アイコン">
        <template #body>
          <div class="pega-icon-area-wrap">
            <label
              v-for="(name) in realIntentionOptions.iconNames"
              :key="name"
              class="pega-icon-area pega-input"
            >
              <img
                :src="`${userRealIntentionImageUrlForPc}/${name}`"
                :data-test="`icon-url-${name}`"
              >
              <input
                v-model="realIntention.icon"
                :data-test="`icon-${name}`"
                :value="name"
                :checked="realIntention.icon === name"
                class="align-center boss-input-checkbox"
                name="icon"
                type="radio"
              >
            </label>
          </div>
        </template>
      </form-label>
    </div>

    <div class="margin-top-2">
      <h3 class="boss-joboffer-title boss-setting">
        質問内容
      </h3>
    </div>

    <div class="cell-auto">
      <form-item-text-area
        v-model="realIntention.question1"
        type="textarea"
        :class-name="question1Validation.isShow ? 'pega-realintention-textarea is-invalid-input': 'pega-realintention-textarea'"
        data-test="question1"
      >
        <template #label>
          <span>
            Q1.あなたの会社はどんな会社だと思う？<br>
            <small>（500文字以内）</small>
          </span>
        </template>
        <template #header>
          <div>
            <small>{{ realIntention.question1.length }}文字/{{ question_max }}文字</small>
          </div>
        </template>
        <template #error>
          <validation-label
            v-if="question1Validation.isShow"
            data-test="question1-error"
            :label="question1Validation.message"
          />
        </template>
      </form-item-text-area>
      <form-item-text-area
        v-model="realIntention.question2"
        type="textarea"
        :class-name="question2Validation.isShow ? 'pega-realintention-textarea is-invalid-input': 'pega-realintention-textarea'"
        data-test="question2"
      >
        <template #label>
          <span>
            Q2.会社の一番良いところは？<br>
            <small>（500文字以内）</small>
          </span>
        </template>
        <template #header>
          <div>
            <small>{{ realIntention.question2.length }}文字/{{ question_max }}文字</small>
          </div>
        </template>
        <template #error>
          <validation-label
            v-if="question2Validation.isShow"
            data-test="question2-error"
            :label="question2Validation.message"
          />
        </template>
      </form-item-text-area>
      <form-item-text-area
        v-model="realIntention.question3"
        :class-name="question3Validation.isShow ? 'pega-realintention-textarea is-invalid-input': 'pega-realintention-textarea'"
        data-test="question3"
      >
        <template #label>
          <span>
            Q3.会社に期待していることは？<br>
            <small>（500文字以内）</small>
          </span>
        </template>
        <template #header>
          <div>
            <small>{{ realIntention.question3.length }}文字/{{ question_max }}文字</small>
          </div>
        </template>
        <template #error>
          <validation-label
            v-if="question3Validation.isShow"
            data-test="question3-error"
            :label="question3Validation.message"
          />
        </template>
      </form-item-text-area>
    </div>

    <div class="margin-top-1 text-center font-bold">
      <span>
        <small data-test="all-required-alert">全て必須項目です。入力漏れにご注意ください。</small>
      </span>
    </div>

    <form-button-area>
      <form-confirm-button
        :is-disabled="hasErrors"
        submit-label="登録内容を確認する"
        data-test="confirm-button"
        @submit-event="onRegisterClick"
      />
    </form-button-area>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { realIntentionRegister } from '@/lib/labelValueMappings'
import SettingHeader from '@/components/atoms/SettingHeader'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import FormItemTextArea from '@/components/atoms/FormItemTextArea'
import FormItemNumber from '@/components/atoms/FormItemNumber'
import FormItem from '@/components/atoms/FormItem'
import FormLabel from '@/components/atoms/FormLabel'
import eventValidations from '@/lib/eventValidations'
import ValidationLabel from '@/components/atoms/ValidationLabel'

const USER_URL = process.env.USER_ENDPOINT

export default {
  components: {
    SettingHeader,
    FormItem,
    FormButtonArea,
    FormConfirmButton,
    FormItemTextArea,
    FormItemNumber,
    FormLabel,
    ValidationLabel
  },
  mixins: [eventValidations],
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    realIntention: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      realIntentionOptions: realIntentionRegister,
      post_max: 200,
      question_max: 500
    }
  },
  computed: {
    userRealIntentionImageUrlForPc: () => `${USER_URL}/th/pc/img/realintention`,
    ...mapGetters({
      allGenders: 'genderMaster'
    }),
    genders () {
      return this.allGenders.filter(gender => gender.id === 1 || gender.id === 2)
    },
    ageValidation () {
      return this.numberValidation(this.realIntention.age, '年齢')
    },
    postValidation () {
      return this.lengthValidation(this.realIntention.post, '所属部署・職種', this.post_max)
    },
    serviceYearValidation () {
      return this.numberValidation(this.realIntention.serviceYear, '入社年数')
    },
    question1Validation () {
      return this.lengthValidation(this.realIntention.question1, '質問内容「Q1」', this.question_max)
    },
    question2Validation () {
      return this.lengthValidation(this.realIntention.question2, '質問内容「Q2」', this.question_max)
    },
    question3Validation () {
      return this.lengthValidation(this.realIntention.question3, '質問内容「Q3」', this.question_max)
    },
    hasErrors () {
      return this.requiredInputValidation(this.realIntention.age) || this.requiredInputValidation(this.realIntention.post) ||
      this.requiredInputValidation(this.realIntention.serviceYear) || this.requiredInputValidation(this.realIntention.question1) ||
      this.requiredInputValidation(this.realIntention.question2) || this.requiredInputValidation(this.realIntention.question3) ||
      this.requiredSelectValidation(this.realIntention.gender.id) || this.requiredSelectValidation(this.realIntention.career.id) ||
      this.requiredSelectValidation(this.realIntention.icon) || this.validated(this.ageValidation) ||
      this.validated(this.serviceYearValidation) || this.validated(this.postValidation) ||
      this.validated(this.question1Validation) || this.validated(this.question2Validation) ||
      this.validated(this.question3Validation)
    },
    title () {
      return this.isEdit ? '編集' : '登録'
    }
  },
  created () {
    this.storeMaster('genders')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    validated (val) {
      return val.isShow === true
    },
    requiredInputValidation (target) {
      if (typeof target === 'string') {
        // 文字列の場合、空白しかない場合も未入力で判定する為
        return target === null || target === undefined || target.trim().length === 0
      } else {
        return target === null || target === undefined || target.length === 0
      }
    },
    requiredSelectValidation (target) {
      return target.length === 0 || target === 0
    },
    async onRegisterClick () {
      if (!this.isEdit) {
        const response = await this.$http.secured.get('/real_intention/real_intentions')
        if (response.data.length >= 100) {
          this.$toasted.global.error({ message: '登録数が100件を超えています。不要な評判を削除してからご登録ください。' })
          return
        }
      }
      this.$emit('filledOut')
    },
    lengthValidation (target, messageTarget, val) {
      return {
        isShow: target.length > val,
        message: `${messageTarget}は${val}文字以内で入力してください`
      }
    },
    numberValidation (target, messageTarget) {
      return {
        isShow: target.length > 0 && !(/^([1-9]\d*|0)$/).test(target),
        message: `${messageTarget}は半角数字で入力してください`
      }
    }
  }
}
</script>
